/**
 * Reverso – Translation, dictionary — inline translation helper
 *
 * Exposes a broad web-accessible-resource group to http(s), ftp, file and even
 * extension origins with no `use_dynamic_url`, globbing the dist assets and
 * quick-control-panel trees plus several named files. The vendor images and the
 * quick-control-panel bundle all resolve from any page at a fixed URL.
 *
 * The Reverso logo is the primary signal — an image, so it loads through `probeImage`
 * with no CORS grant and survives a strict page CSP. A second image and a panel
 * stylesheet corroborate.
 *
 * Manifest verified against version 3.11.387.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'onhiacboedfinnofagfgoaanfedhmfab';

export const reverso: ExtensionDefinition = {
  id: ID,
  name: 'Reverso – Translation, dictionary',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Broad static WAR on http(s)/ftp/file origins with no dynamic URL. Loading the ' +
    'Reverso logo is conclusive and needs no CORS grant; a second image and the panel CSS corroborate.',
  signals: [
    {
      id: 'war-reverso-logo-png',
      kind: 'web-accessible-resource',
      description:
        'Load dist/assets/images/reverso-logo.png via <img> — a vendor logo exposed to ' +
        'every origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'dist/assets/images/reverso-logo.png'),
    },
    {
      id: 'war-feedback-icon-png',
      kind: 'web-accessible-resource',
      description: 'Load dist/assets/images/feedback-icon.png via <img> — a second image, corroborating.',
      weight: 0.5,
      run: () => probeImage(ID, 'dist/assets/images/feedback-icon.png'),
    },
    {
      id: 'war-quick-control-panel-styles-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch dist/quick-control-panel/styles.css — the control-panel stylesheet, an ' +
        'independent non-image path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'dist/quick-control-panel/styles.css'),
    },
  ],
};
